import React from "react";
import {withRouter} from "react-router-dom";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import {Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, Row} from "reactstrap";
import {ToastContainer} from "react-toastify";
import PasswordResetService from "../../services/PasswordResetService";
import ToastHelper from "../../utils/ToastHelper";
import '../../scss/ResetPassword.css'

class ResetPassword extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            username: "",
            phoneNumber: ""
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    validateForm() {
        return this.state.username.length > 0 && this.state.phoneNumber.length > 0;
    }

    handleChange = event => {

        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit(event) {
        if (event.preventDefault) event.preventDefault();

        PasswordResetService.resetPassword(this.state.username, this.state.phoneNumber).then(response => {
            if (response === 'success') {
                ToastHelper.success("Password reset successful");
            } else {
                ToastHelper.error(response.message);
            }
        })

    }

    render() {

        return <div className="app flex-row align-items-center">
            <Container className={"logo-center"}>
                <Row className="justify-content-center">
                    <Col md="8">
                        <CardGroup>
                            <Card className="p-2">
                                <CardBody>
                                    <Form onSubmit={this.handleSubmit}>
                                        <main>
                                            <ToastContainer position="top-right" autoClose={5000}
                                                            style={{zIndex: 1999}}/>
                                        </main>
                                        <Col>
                                            <Row className="resetPassword" >
                                                <h4>{"Reset Password"}</h4>
                                            </Row>
                                            <hr/>
                                            <InputGroup className="mb-3">
                                                <Input className="form-control input-lg"
                                                       type="text"
                                                       placeholder="Username"
                                                       autoComplete="username"
                                                       id="username"
                                                       autoFocus
                                                       onChange={this.handleChange}
                                                       value={this.state.username}/>
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <Input className="form-control input-lg"
                                                       type="text"
                                                       placeholder="Phone Number"
                                                       id="phoneNumber"
                                                       autoComplete="phone-number"
                                                       onChange={this.handleChange}
                                                       value={this.state.phoneNumber}/>
                                            </InputGroup>
                                            <Row className="resetPassword">
                                                <SFXButtonComponent className="btn btn-lg btn-block btn-primary"
                                                                    disabled={!this.validateForm()}>
                                                    Reset Password
                                                </SFXButtonComponent>
                                                <SFXButtonComponent className="btn btn-lg btn-block btn-secondary"
                                                                    onClick={() => this.props.history.replace("/")}
                                                >
                                                    {"Back"}
                                                </SFXButtonComponent>
                                            </Row>
                                        </Col>
                                    </Form>
                                </CardBody>
                            </Card>
                        </CardGroup>
                    </Col>
                </Row>
            </Container>
        </div>

    }

}

export default withRouter(ResetPassword);